import { createStore } from 'satcheljs';

export default createStore('OWAAccountsStoreInitStore', {
    isAccountsStoreInitialized: false,
});
